export class InterceptorError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'InterceptorError'
    Object.setPrototypeOf(this, InterceptorError.prototype)
  }
}
